import React from 'react';

const EndSection = props => {
    const { children } = props;
    return (
        <div className="bookmark justify-content-end">
            {children}
        </div>
    );
};

export default EndSection;
